import { AdminService } from '../services/adminService';
import { persistExerciseListFilters } from './exerciseListNavigation';
import { enrichGenerationParameters } from './taxonomyGenerationParams';
import { getAssociationFitAssessment } from '../config/shared_config';

const GAME_DEFAULTS = {
  speed_game: { totalWords: 10, numOptions: 4 },
  word_lists: { totalWords: 10 },
  dictation: { totalWords: 10, mode: 'text' },
  text_holes: {},
  correction_game: {},
  association: {},
  categorisation: {},
  speed_sort: {},
};

export function buildGenerationParameters(taxonomyTriplet, { schoolLevel, difficulty, gameType }) {
  const parameters = {
    schoolLevel,
    difficulty: difficulty || 'medium',
    competence: {
      domain: taxonomyTriplet.domain,
      competence: taxonomyTriplet.competence,
      notion: taxonomyTriplet.notion,
    },
    ...(GAME_DEFAULTS[gameType] || {}),
  };
  return enrichGenerationParameters(parameters, gameType);
}

function buildExerciseTitle({ notionLabel, gameTypeLabel, index, total }) {
  const suffix = total > 1 ? ` (${index + 1}/${total})` : '';
  return `${notionLabel} — ${gameTypeLabel}${suffix}`;
}

/**
 * Génère et enregistre un ou plusieurs exercices LLM pour un triplet taxonomique.
 */
export async function generateTaxonomyExercises({
  taxonomyTriplet,
  notionLabel,
  gameType,
  gameTypeLabel,
  schoolLevel,
  difficulty,
  count = 1,
  onProgress,
}) {
  const parameters = buildGenerationParameters(taxonomyTriplet, {
    schoolLevel,
    difficulty,
    gameType,
  });
  const createdIds = [];
  const warnings = [];
  const safeCount = Math.min(Math.max(parseInt(count, 10) || 1, 1), 5);

  if (gameType === 'association') {
    const fit = getAssociationFitAssessment(
      taxonomyTriplet.domain,
      taxonomyTriplet.competence,
      taxonomyTriplet.notion,
    );
    if (!fit.fit && fit.reason) {
      warnings.push(fit.reason);
    }
  }

  for (let i = 0; i < safeCount; i += 1) {
    onProgress?.({ current: i + 1, total: safeCount, phase: 'generate' });
    const generated = await AdminService.generateExercise({ gameType, parameters });
    if (!generated?.generatedContent) {
      throw new Error('Contenu généré vide');
    }
    if (Array.isArray(generated.warnings)) {
      warnings.push(...generated.warnings);
    }
    const savedParameters = generated.parameters || parameters;

    onProgress?.({ current: i + 1, total: safeCount, phase: 'save' });
    const created = await AdminService.createExercise({
      type: 'llm',
      gameType,
      parameters: savedParameters,
      content: generated.generatedContent,
      title: buildExerciseTitle({
        notionLabel,
        gameTypeLabel,
        index: i,
        total: safeCount,
      }),
      description: '',
      isActive: true,
      validationStatus: 'nouveau',
    });
    createdIds.push(created.id);
  }

  persistExerciseListFilters({
    gameType,
    domain: taxonomyTriplet.domain,
    competence: taxonomyTriplet.competence,
    notion: taxonomyTriplet.notion,
  });

  return { createdIds, parameters, warnings: [...new Set(warnings)] };
}
